module.exports = __webpack_public_path__ + "assets/img/1471587607609_.pic_hd.04896607.jpg";